import { ACT_APP_CHANGE } from "../actions/ActionTypes";

const initialState = {
	loading: 0,
	login: false, //cambiar esto a false
	username: "Germán", //Limpiar
	email: "german.dias@gmail.com", //Limpiar
	rol: "administrador", //cambiar esto a vacío
	active: false,
	permissions: {
		countries: "",
		benefit: "",
		products: ""
	}
};

export default function(state = initialState, action) {
	if (action.type === ACT_APP_CHANGE) {
		return Object.assign({}, state, action.props);
	}
	return state;
}



// WEBPACK FOOTER //
// ./src/reducers/AppReducer.js